import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import FormField from "../fields/FormField";
import Label from "../../../atoms/label/Label";
import Tooltip from "../../../atoms/tooltip/Tooltip";

class SelectInput extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.showPromoted = this.showPromoted.bind(this);
  }

  onChange(field, form, event) {
    const { name, onChange } = this.props;
    const { target } = event;
    const { value } = target;

    if (onChange) {
      onChange(value);
    }

    form.setFieldValue(name, value);
  }

  showPromoted() {
    const { promotedOptions, options } = this.props;

    if (options && promotedOptions) {
      const promotedOptionsArray = promotedOptions.split(",");

      const output = [];
      promotedOptionsArray.map(promotedOption => {
        if (options.some(option => option.key === promotedOption)) {
          const option = options.find(option => option.key === promotedOption);
          return output.push(
            <option key={promotedOption} value={promotedOption}>
              {option.value}
            </option>
          );
        }

        return null;
      });

      if (output.length > 0) {
        output.push(
          <option key="0" value="0" disabled>
            -----
          </option>
        );
      }

      return output;
    }
  }

  render() {
    const {
      label,
      tooltip,
      name,
      options,
      promotedOptions,
      classes,
      required,
      selectPlaceholder,
      children,
      ...rest
    } = this.props;

    return (
      <>
        <FormField name={name}>
          <Label text={label} id={name} required={required} />
          {tooltip && <Tooltip text={tooltip} />}
          <Field name={name} id={name}>
            {({ field, form }) => (
              <select
                {...rest}
                {...field}
                className={classes}
                onChange={event => this.onChange(field, form, event)}
                id={name}
              >
                {selectPlaceholder && (
                  <option hidden value="-1">
                    {selectPlaceholder}
                  </option>
                )}

                {this.showPromoted()}

                {options &&
                  options.length > 0 &&
                  options.map(option => (
                    <option key={option.key} value={option.key}>
                      {option.value}
                    </option>
                  ))}
              </select>
            )}
          </Field>
          <div className="col col-auto">{children}</div>
        </FormField>
      </>
    );
  }
}

SelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  classes: PropTypes.string,
  required: PropTypes.bool,
  promotedOptions: PropTypes.string,
  options: PropTypes.shape({
    key: PropTypes.string
  }).isRequired,
  selectPlaceholder: PropTypes.string,
  onChange: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ])
};

SelectInput.defaultProps = {
  classes: "form-item__select select--stretch",
  promotedOptions: "",
  selectPlaceholder: "",
  tooltip: "",
  required: false,
  onChange: () => {},
  children: []
};

export default SelectInput;
